var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VanBtn',{staticClass:"submit-btn",attrs:{"color":"","size":"large"}},[_c('div',{staticClass:"text"},[_vm._t("default"),(_vm.countdown)?_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.countdown))]):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }